import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { BaseSlider } from '@theme/slider';

class ProductMedia extends HTMLElement {
  #closestSection = null;

  connectedCallback() {
    this.#closestSection = this.closest('.shopify-section');
    this.#closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#updateMedia);
  }

  disconnectedCallback() {
    this.#closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#updateMedia);
    this.#closestSection = null;
  }

  get #productId() {
    return this.getAttribute('data-product-id');
  }

  /**
   * Replaces the product media element with the new HTML from the variant update event.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #updateMedia = (event) => {
    const target = event.target;

    if (target instanceof HTMLElement && target.getAttribute('data-product-id') !== this.#productId) {
      return;
    }

    if (event.detail.data.source === 'selling-plan') {
      return;
    }

    const { html } = event.detail.data;

    const newElement = html.querySelector(this.tagName.toLowerCase());

    if (!newElement) return;

    this.classList.add('is-exiting');
    this.addEventListener('animationend',
      () => this.replaceWith(newElement), { once: true }
    );
  };
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia);
}

class ProductSlider extends BaseSlider {
  initSlider() {
    const thumbnailsSelector = this.getAttribute('thumbnails');
    const thumbnailsEl = thumbnailsSelector ? document.querySelector(thumbnailsSelector) : null;

    if (thumbnailsEl && !thumbnailsEl.swiperInstance) {
      thumbnailsEl.addEventListener('slider:initialized', () => super.initSlider(), { once: true });
      return;
    }

    super.initSlider();
  }

  get options() {
    const thumbnailsSelector = this.getAttribute('thumbnails');
    const thumbnailsEl = thumbnailsSelector ? document.querySelector(thumbnailsSelector) : null;
    const thumbnailsSwiper = thumbnailsEl?.swiperInstance;

    return {
      ...super.options,
      ...(thumbnailsSwiper && {
        thumbs: { swiper: thumbnailsSwiper }
      }),
      on: {
        ...super.options.on,
      }
    };
  }
}

if (!customElements.get('product-slider')) {
  customElements.define('product-slider', ProductSlider);
}
